const calendar = {
  en: {
    translation: {
      closing_days: "Closing days",
      business_openings: "Add openings",
      open_all_day: "Open all day",
      add: "Add",
      holidays: "Holidays",
      from: "From",
      to: "to",
      dateFrom: "From",
      dateTo: "To",
      ceased_activity: "Ceased activity",
      save_success_text_joined:
        "Your changes have been saved successfully, days with the same opening and closing times have been grouped together"
    }
  },
  it: {
    translation: {
      closing_days: "Giorni di chiusura",
      business_openings: "Aggiungi orari",
      open_all_day: "Aperto 24 ore su 24",
      add: "Aggiungi",
      holidays: "Ferie",
      from: "Dal",
      to: "al",
      dateFrom: "Dal",
      dateTo: "Al",
      ceased_activity: "Chiusura attività",
      save_success_text_joined:
        "Le tue modifiche sono state salvate con successo, i giorni con gli stessi orari di apertura e chiusura sono stati raggruppati"
    }
  }
};

export default calendar;
